import { Component, OnInit, Inject } from '@angular/core';
import { Router}   from '@angular/router';

import { BaseService }   from '../shared-service/base.service';
import { LoginService }   from './login.service';
import { APP_CONFIG, AppConfig } from '../shared-service/app.config'; 

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

   
    error: Object|any = {};
	
	constructor(public bs:BaseService, private loginService:LoginService, private router: Router, @Inject(APP_CONFIG) private config: AppConfig) {
		this.bs.log('info',"LoginComponent Loaded");
       
        this.error['err'] = false;
        
        this.bs.log('info',this.bs.config["apiEndpoint"]);
        
	    // if (this.loginService.getStoreLoginData(config.storageLoginKey)) {
	    //     this.router.navigate(['learner/learning']);
	    // } 
    }

	ngOnInit() {
    }
    
    
	validateLogin(uId:any, pwd:any) {
        const body = {"userName":uId,"password":pwd,"IPAddress":"000.00.0.0","deviceUUID":"","corporateID":1};


        this.loginService.getLoginDetailFromServer(body, this.config.storageLoginKey,"freshLogin").then((res:any)=>{
            
            sessionStorage.setItem("user", JSON.stringify(res));
            this.bs.loadUserAccount(res);

            const sResource = {"CorporateId": res['CorporateId'] ,"Culture": res['Culture']};
            this.loginService.getStringResourceFromServer(sResource, this.config.storageResourcesKey).then((res)=>{

                sessionStorage.setItem("resource", JSON.stringify(res));
                this.bs.loadStringResources(res);
                this.bs.setUserAtibuteLoded(true);
                //I will take care of loading Nav
                this.router.navigate(['learner']);

            },(res)=>{
               
            });
        },(res)=>{
           
        });
    };

}
